export const WHATSAPP_COMMUNITY_URL =
  'https://chat.whatsapp.com/BV9LMJnV2gV5DQbpt5ZNoA?s=cl&p=i&mlu=4';

export const COMMUNITY_MODAL_DISMISSED_KEY = 'community_modal_dismissed';

type CommunityPromptStorage = Pick<Storage, 'setItem'>;

export function dismissCommunityPrompt(storage: CommunityPromptStorage): void {
  storage.setItem(COMMUNITY_MODAL_DISMISSED_KEY, '1');
}
